/* groovi-drawer-dismiss.js — light dismiss for the DESKTOP cart drawer (spec 2.11).

   Below 990px the cart <dialog> opens as a MODAL (theme-drawer.js showModal), so the
   native backdrop click already closes it (#onBackdropClick). At >=990px it opens
   NON-modal (show()) with NO ::backdrop, so clicking outside never closes it — this
   fills that gap. The menu drawer (<details>) is light-dismissed natively by
   auto-close-details.js, so this script is desktop-cart-only.

   We simulate the user's own close by clicking the drawer's close button, so the
   theme-drawer component runs its native close animation + focus handling — we never
   reach past the component API. Clicks inside the panel, and clicks on the cart
   toggle/cart links (which manage their own open state), are ignored. */
(function () {
  'use strict';

  var desktop = window.matchMedia('(min-width: 990px)');

  document.addEventListener(
    'pointerdown',
    function (event) {
      if (!desktop.matches) return;

      var dialog = document.querySelector('#cart-drawer .theme-drawer__dialog[open]');
      if (!dialog) return;

      var target = event.target;
      if (!(target instanceof Element)) return;

      // Inside the panel → keep it open (interacting with the cart).
      if (target.closest('.theme-drawer__dialog')) return;

      // An add behind an open desktop drawer should update it in place, rather
      // than light-dismiss now and replay the slide-in after the response.
      if (target.closest('[ref="addToCartButton"], [data-add], [data-bundle-submit]')) return;

      // The cart toggle / any cart link manages its own open/close — don't fight it.
      if (
        target.closest(
          'a[href*="/cart"], [ref="cartIcon"], cart-icon-component, [aria-controls="cart-drawer"], [on\\:click*="cart"]'
        )
      ) {
        return;
      }

      var closeButton = dialog.querySelector('.theme-drawer__close-button');
      if (closeButton) closeButton.click();
    },
    true
  );
})();
